/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WorkflowTaskErrorDto = {
  id: string;
  taskId: string;
  timestamp: string;
  attemptNumber: number;
  /**
   * Domain-specific error code (e.g., EMPLOYEE:DUPLICATE_EMAIL)
   */
  code: string;
  message: string;
  severity: WorkflowTaskErrorDto.severity;
  originalError?: Record<string, any>;
  stackTrace?: string;
  retryable: boolean;
  suggestedAction?: string;
  documentationUrl?: string;
  itemData?: Record<string, any>;
  relatedIds?: Record<string, any>;
  correlationId: string;
};
export namespace WorkflowTaskErrorDto {
  export enum severity {
    WARNING = 'WARNING',
    ERROR = 'ERROR',
    CRITICAL = 'CRITICAL',
  }
}
